/*
   Entry points whose flow is not finished, and what the console does instead.

   A control that opens a half-built flow is worse than one that declines: the
   user commits effort before anything tells them the product cannot finish the
   job, and the failure arrives at the point of most investment. So the control
   stays where it is — the shape of the product is honest — and answers rather
   than opening something that dead-ends.

   The flags are the single place that knows which flows are live, so turning
   one on is one edit here; every call site already reads it.
*/
export const FEATURES: Record<FeatureName, boolean> = {
  /** Three-step intake: printed label → master → engagement. */
  newReview: false,
  /** Creating an engagement, with its client contacts. */
  newEngagement: false,
  /** Long-lived machine credentials: issuing, listing, revoking. */
  serviceApiKeys: false,
  /** The per-version review workspace. */
  reviewDetail: false,
}

export type FeatureName = "newReview" | "newEngagement" | "serviceApiKeys" | "reviewDetail"

/** What an unfinished entry point says when used. */
export const COMING_SOON = {
  tone: "neutral",
  title: "Coming soon",
  description: "This part of the console is still being built.",
} as const
